<template>
  <div
    class="tw-flex tw-items-center tw-py-6 tw-gap-6 hover:tw-bg-light dark:hover:tw-bg-dm-light tw-px-6"
  >
    <div
      class="tw-flex tw-items-center"
      :style="`width: ${columns[0].width}`"
    >
      {{ place.short_name }}
    </div>

    <div :style="`width: ${columns[1].width}`">
      {{ place.full_address }}
    </div>

    <div :style="`width: ${columns[2].width}`">
      <div
        class="tw-flex tw-items-center tw-gap-2"
      >
        <i-button
          type="white"
          is-icon
          @click="isEditPlaceDialogOpen = true"
        >
          <icon-edit />
        </i-button>
        <i-confirm-popover
          :cancel-text="$t('common.actions.cancel')"
          :submit-text="$t('common.actions.delete')"
          @submit="deleteUser"
        >
          <template #reference>
            <i-button
              type="white"
              is-icon
              class="tw-text-primary"
              :is-loading="isDeleting"
            >
              <icon-trash />
            </i-button>
          </template>
          <template #content>
            <div>
              {{ $t('adm.permits.places.delete_dialog.confirm_text') }}
              {{ place.short_name }}
            </div>
          </template>
        </i-confirm-popover>
      </div>
    </div>
    <EditInternalPlaceDialog
      :is-open="isEditPlaceDialogOpen"
      :place-id="place.id"
      @close="isEditPlaceDialogOpen = false"
    />
  </div>
</template>

<script>

import { getValidationError } from '@/helpers';
import EditInternalPlaceDialog from '@/components/Administration/Internal/Places/EditInternalPlaceDialog.vue';

export default {
  name: 'InternalPlacesListItem',
  components: { EditInternalPlaceDialog },
  props: {
    place: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isEditPlaceDialogOpen: false,
      isDeleting: false,
    };
  },

  methods: {
    async deleteUser() {
      this.isDeleting = true;
      try {
        await this.$store.dispatch('v2/admin/cms/internal/places/deletePlace', this.place.id);
      } catch (e) {
        const errorText = getValidationError(e);

        this.$message.error({
          message: errorText,
          showClose: true,
          dangerouslyUseHTMLString: true,
        });
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>
